import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_KEYSTONE_DUNGEON_RUNS,
  SET_KEYSTONE_DUNGEON_RUNS_LOADING,
  SET_KEYSTONE_RUN_DETAILS,
  SET_KEYSTONE_RUN_FORCE_REFRESH,
  SET_KEYSTONE_RUN_LOADING,
  SET_KEYSTONE_RUN_SELECTED_VIDEO,
  TOGGLE_KEYSTONE_EVENT_BREAKDOWN,
  SET_KEYSTONE_RUN_ROUTE_SHOWING,
  TOGGLE_OPEN_MYTHIC_PLUS_RUN,
  TOGGLE_OPEN_RECENT_RUN
} from '../actions/keystoneActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TCharacterDetailsClientState } from '../libs/store';

export default function keystoneRuns(
  state: Partial<TCharacterDetailsClientState> = {},
  action: TAction<any>
): Partial<TCharacterDetailsClientState> {
  switch (action.type) {
    case TOGGLE_OPEN_MYTHIC_PLUS_RUN: {
      return {
        ...state,
        openRuns: {
          ...(state.openRuns || {}),
          [action.payload]: state.openRuns ? !state.openRuns[action.payload] : true
        }
      };
    }
    case TOGGLE_KEYSTONE_EVENT_BREAKDOWN: {
      return {
        ...state,
        openEventBreakdown: {
          ...(state.openEventBreakdown || {}),
          [action.payload]: state.openEventBreakdown ? !state.openEventBreakdown[action.payload] : true
        }
      };
    }
    // FIXME: should probably move this to have a `key` like the other M+ run actions
    case TOGGLE_OPEN_RECENT_RUN: {
      return {
        ...state,
        openRecentRuns: {
          ...(state.openRecentRuns || {}),
          [action.payload]: state.openRecentRuns ? !state.openRecentRuns[action.payload] : true
        }
      };
    }
    case SET_KEYSTONE_DUNGEON_RUNS: {
      const newState: any = {
        dungeonRuns: {},
        loadingDungeons: {},
        loadedDungeons: {},
        openRuns: {},
        openRecentRuns: {},
        ...state
      };
      newState.dungeonRuns[action.payload.key] = action.payload.runs;
      newState.loadedDungeons[action.payload.key] = true;
      newState.loadingDungeons[action.payload.key] = false;

      // // open the first run in the list if this is the first load
      // newState.openRuns[action.payload.runs[0].keystone_run_id] = true;
      // openRuns: (state.dungeons || !action.payload.dungeons || !action.payload.dungeons.length) ? {} : {
      //   [action.payload.dungeons[0].keystone_run_id]: true
      // },

      return newState;
    }
    case SET_KEYSTONE_DUNGEON_RUNS_LOADING: {
      const newState: any = {
        ...state,
        ...{
          loadingDungeons: {
            ...(state.loadingDungeons || {}),
            [action.payload.key]: action.payload.loading
          }
        }
      };
      return newState;
    }
    case SET_KEYSTONE_RUN_LOADING: {
      const newState: any = {
        ...state,
        ...{
          loadingRuns: {
            ...(state.loadingRuns || {}),
            [action.payload.keystoneRunId]: action.payload.loading
          }
        },
        ...{
          forceRefresh: {
            ...(state.forceRefresh || {}),
            [action.payload.keystoneRunId]: false
          }
        }
      };
      return newState;
    }
    case SET_KEYSTONE_RUN_DETAILS: {
      const newState: any = {
        runs: {},
        loadingRuns: {},
        forceRefresh: {},
        loadedRuns: {},
        ...state
      };
      newState.runs[action.payload.keystoneRunId] = action.payload.details;
      newState.forceRefresh[action.payload.keystoneRunId] = false;
      newState.loadedRuns[action.payload.keystoneRunId] = true;
      newState.loadingRuns[action.payload.keystoneRunId] = false;
      return newState;
    }
    case SET_KEYSTONE_RUN_SELECTED_VIDEO: {
      const newState = {
        ...state
      };
      newState.runs[action.payload.keystoneRunId] = {
        ...newState.runs[action.payload.keystoneRunId],
        selectedVideo: {
          ...action.payload.video,
          autoPlay: true
        }
      };
      return newState;
    }
    case SET_KEYSTONE_RUN_FORCE_REFRESH: {
      const newState: any = {
        forceRefresh: {},
        ...state
      };
      newState.forceRefresh[action.payload.keystoneRunId] = true;
      return newState;
    }
    case SET_KEYSTONE_RUN_ROUTE_SHOWING: {
      const newState: any = {
        ...state,
        runs: {
          ...state.runs,
          [action.payload.keystoneRunId]: {
            ...(state.runs[action.payload.keystoneRunId] || {}),
            showRoute: action.payload.show
          }
        }
      };

      return newState;
    }
    case LOCATION_CHANGE: {
      rioDebouncedRefreshWowheadTooltips();
      return state;
    }
    default: {
      return state;
    }
  }
}
